import React from "react";
import styled from "styled-components";
import EditIcon from "../../../../assets/icons/Edit-icon.svg";
import DeleteIcon from "../../../../assets/icons/delete-icon-mip.png";
import WarningInfoIcon from "../../../../assets/icons/WarningIcon.png";
import "../../TechnicianAppointmentsModal.css";
import { useSelector } from "react-redux";
import { getPendoId } from "../../../../util/cfstPendoUtils";
import { DEVICE_BREAKPOINTS } from "../../../../constants/appConstants";
import PropTypes from "prop-types";
const { TABLET } = DEVICE_BREAKPOINTS;

export const Wrapper = styled.div`
  background: ${(props) => (props.background ? props.background : "#FFF")};
  border: ${(props) => (props.border ? props.border : "")};
  border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "")};
  display: flex;
  flex-direction: ${(props) => (props.flexDirection ? props.flexDirection : "row")};
  padding: ${(props) => props.padding};
  width: ${(props) => props.width};
  align-items: ${(props) => props.alignItems};
  align-self: ${(props) => props.alignSelf};
  justify-content: ${(props) => props.justifyContent};
  gap: ${(props) => props.gap};
  margin-top: ${(props) => props.marginTop};
  cursor: ${(props) => (props.cursor ? props.cursor : "")};
`;

export const CustomizedWrapper = styled(Wrapper)`
  &:focus {
    border: 2px solid #006fc1; /* Add border on focus */
    outline: none; /* Remove default outline */
  }
  &:hover {
    background: #0000000d;
    border: 1px solid #d8dada;
  }
  &:active {
    background: #0000001f; /* Change background on press */
    border: 1px solid #d8dada; /* Add border on press */
  }
`;
export const TextWrapper = styled.p`
  font-family: Neue Haas Grotesk Text Std;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  margin: ${(props) => (props.margin ? props.margin : "0")};
`;

export const TextWrapperSpan = styled.span`
  font-family: Neue Haas Grotesk Text Std;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  margin: ${(props) => (props.margin ? props.margin : "0")};
`;

export const Img = styled.img`
  width: 25px;
  height: 25px;
  padding: 5px;
  cursor: pointer;
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  cursor: default;

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

export const ActionButton = styled.button`
  position: relative;
  padding: 0px;
  margin: 0px;
  background: transparent;
  border: none;
  &:hover {
    background: #0000000d;
    border-radius: 50%;
    transition: background 0.3s ease, transform 0.3s ease;
  }
  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

const Tooltip = styled.div`
  visibility: hidden;
  opacity: 0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background-color: black;
  color: white;
  padding: 4px 8px;
  border-radius: 0.5rem;
  white-space: nowrap;
  transition: opacity 0.3s ease;
  font-family: Neue Haas Grotesk Text Std;
  font-weight: 300;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0%;
`;

const ServiceContainer = styled(Wrapper)`
  @media (max-width: 767px) {
    padding: 1rem;
    margin-top: 1rem;
    & .service {
      flex-direction: column;
    }
  }
`;

function AdditionalService({ index, record, isEditVehicleAssetDetails, editVehicleDetails, deleteVehicleDetails, handleVehicleAssetDetails }) {
  const { windowSize } = useSelector((state) => state.ACCOUNT);
  const hasAccessoriesConnected = (accessories) => accessories !== "No accessories connected";

  const selectedAccessories = record.selectedCameraAndAccessories && record.selectedCameraAndAccessories.filter(hasAccessoriesConnected).length > 0;
  const renderAccessories = (selectedAccessories, record) => {
    if (!selectedAccessories) return null;

    return (
      <>
        <b>{`Accessories: `}</b>
        <TooltipWrapper>
          {record.selectedCameraAndAccessories.length}
          <Tooltip className="tooltip">
            {record.selectedCameraAndAccessories.map((item) => (
              <div key={item}>{item}</div>
            ))}
          </Tooltip>
        </TooltipWrapper>
      </>
    );
  };

  const getResponsiveWidth = (windowWidth) => {
    if (windowWidth >= TABLET && windowWidth < 1300) return "35%";
    if (windowWidth >= 1300) return "40%";
    return "auto";
  };

  const truncateVehicleName = (vehicleName, maxLength = 35) => {
    if (!vehicleName || typeof vehicleName !== "string") return "";
    return vehicleName.length > maxLength ? `${vehicleName.slice(0, maxLength)}...` : vehicleName;
  };
  const renderVehicleDetails = (record, windowSize) => {
    const vehicleName = truncateVehicleName(record?.selectedVinOrPA?.vehicleName);

    return (
      <TextWrapper
        fontSize="0.875rem"
        fontWeight="400"
        lineHeight="1.25rem"
        margin="0 1.5rem 0 0"
        style={{
          width: getResponsiveWidth(windowSize.width),
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        <b>{`${record.selectedVinOrPA.isVin ? "Vehicle" : "Powered asset"}: `}</b>
        {vehicleName}
      </TextWrapper>
    );
  };

  const renderActionButtons = (index, editVehicleDetails, deleteVehicleDetails) => (
    <Wrapper gap="0.5rem" justifyContent="center" alignItems="flex-start" alignSelf="stretch">
      <ActionButton
        tabIndex={0}
        onClick={() => editVehicleDetails(index)}
        aria-label="Edit button"
        // role="button"
        id={getPendoId("additional-service-edit-icon")}
      >
        <Img src={EditIcon} />
        <Tooltip className="tooltip">Edit Service</Tooltip>
      </ActionButton>
      <ActionButton
        tabIndex={0}
        onClick={() => deleteVehicleDetails(index)}
        aria-label="Delete button"
        // role="button"
        id={getPendoId("additional-service-delete-icon")}
      >
        <Img src={DeleteIcon} />
        <Tooltip className="tooltip">Delete Service</Tooltip>
      </ActionButton>
    </Wrapper>
  );

  const renderServiceDetails = (record, index, windowSize, selectedAccessories) => (
    <Wrapper className="service" gap="0.5rem" flexDirection="row" justifyContent="flex-start" alignItems="center" alignSelf="stretch">
      {(record.isWarning || record.isVinInvalid) && (
        <img src={WarningInfoIcon} aria-label={record.isWarning ? "agent assistance required warning" : record.errorReason} />
      )}
      <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem" margin="0 1.5rem 0 0" style={{whiteSpace: "nowrap"}}>
        <b>{`Service ${index + 1}: `}</b>
        {record.serviceType}
      </TextWrapper>
      {renderVehicleDetails(record, windowSize)}
      <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem" margin="0 1.5rem 0 0" style={{whiteSpace: "nowrap"}}>
        {renderAccessories(selectedAccessories, record)}
      </TextWrapper>
    </Wrapper>
  );

  const renderServiceContainer = (record, index, windowSize, selectedAccessories, editVehicleDetails, deleteVehicleDetails) => (
    <ServiceContainer
      borderRadius="0.5rem"
      border="1px solid #D8DADA"
      width={"100%"}
      padding={windowSize.width > 767 && windowSize.width < 800 ? "1.5rem 0.25rem 1.5rem 0.25rem" : "1.5rem"}
      justifyContent="space-between"
      alignItems="flex-start"
      gap="1.5rem"
      marginTop="1rem"
      key={index}
    >
      {renderServiceDetails(record, index, windowSize, selectedAccessories)}
      {renderActionButtons(index, editVehicleDetails, deleteVehicleDetails)}
    </ServiceContainer>
  );

  const renderCompactServiceContainer = (record, index, selectedAccessories, editVehicleDetails, deleteVehicleDetails) => (
    <Wrapper
      borderRadius="0.5rem"
      border="1px solid #D8DADA"
      width={"100%"}
      padding="1rem"
      justifyContent="space-between"
      alignItems="flex-start"
      gap="0.5rem"
      marginTop="1rem"
      key={index}
      flexDirection={"column"}
    >
      <Wrapper gap="0.5rem" flexDirection={"row"} justifyContent="space-between" alignItems="center" alignSelf="stretch">
        <Wrapper gap="0.5rem">
          {(record.isWarning || record.isVinInvalid) && (
            <img src={WarningInfoIcon} aria-label={record.isWarning ? "agent assistance required warning" : record.errorReason} />
          )}
          <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem">
            <b>{`Service ${index + 1}: `}</b>
            {record.serviceType}
          </TextWrapper>
        </Wrapper>
        {renderActionButtons(index, editVehicleDetails, deleteVehicleDetails)}
      </Wrapper>
      <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem" margin="0">
        <b>{`${record.selectedVinOrPA.isVin ? "Vehicle" : "Powered asset"}: `}</b>
        {record.selectedVinOrPA.vehicleName}
      </TextWrapper>
      <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem" margin="0">
        {selectedAccessories && (
          <>
            <b>{`Accessories: `}</b>
            {record.selectedCameraAndAccessories.length}
          </>
        )}
      </TextWrapper>
    </Wrapper>
  );
  const renderContent = () => {
    if (isEditVehicleAssetDetails.isOpen && isEditVehicleAssetDetails.index === index) {
      return handleVehicleAssetDetails(index);
    }
    if (windowSize.width >= TABLET) {
      return renderServiceContainer(record, index, windowSize, selectedAccessories, editVehicleDetails, deleteVehicleDetails);
    }
    return renderCompactServiceContainer(record, index, selectedAccessories, editVehicleDetails, deleteVehicleDetails);
  };
  return <>{renderContent()}</>;
}
AdditionalService.propTypes = {
  index: PropTypes.number.isRequired,
  record: PropTypes.object.isRequired,
  isEditVehicleAssetDetails: PropTypes.object.isRequired,
  editVehicleDetails: PropTypes.func.isRequired,
  deleteVehicleDetails: PropTypes.func.isRequired,
  handleVehicleAssetDetails: PropTypes.func.isRequired,
};

export default AdditionalService;
